import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { HttpErrorService } from '../../services/http-error/http-error.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '@benefitsui/environments/environment';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorService: HttpErrorService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    const { errorRedirectPrevented } = this.errorService.getPreventedRedirects();
    return next.handle(req).pipe(
      catchError((e) => {
        const envName = environment.environmentName;
        if (e instanceof HttpErrorResponse) {
          if (e.status === 400 && e.url?.includes('overview')) {
            this.errorService.navigateToSearch();
          } else if (e.status === 401 && envName.indexOf('demo') !== -1) {
            this.errorService.navigateToDemoLogin();
          } else if (e.status === 401) {
            this.errorService.navigateToLogin();
          } else if (e.status === 403) {
            this.errorService.navigateToNoAccess();
          } else if (!errorRedirectPrevented) {
            if (e.status === 500 && (this.router.url.includes('documents') || this.router.url.includes('allforms'))) {
              return throwError(e);
            }
            this.errorService.navigateToError();
          }
        }
        return throwError(e);
      })
    );
  }
}

export const httpErrorInterceptorProviders: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
];

